function cx(...names) {
  return names.filter(Boolean).join(" ");
}
export {
  cx
};
//# sourceMappingURL=cx.js.map
